import { useEffect, useState } from 'react';
import useVerifiedUserAuth0 from './UseVerifiedUserAuth0';

const useVerifySessionAuth0 = (callbackFunc) => {
    const [isLoadingProcess, setIsLoadingProcess] = useState(false);
    const [isVerified, isLoadingVerify] = useVerifiedUserAuth0();

    useEffect(async () => {
        setIsLoadingProcess(true);
        if (!isLoadingVerify) {
            await callbackFunc(isVerified);
        }
    }, [isVerified, isLoadingVerify]);
    
    return [isLoadingProcess]
}

export default useVerifySessionAuth0;